import styled from 'styled-components';
import { MaterialInputCustom } from './CurrencyInput';
import { StyleProps } from './types';

export const MaterialInputCustomFormula = styled(MaterialInputCustom).attrs<StyleProps>((props) => ({
  ...props,
  currencyPx: 14,
  style: {},
}))`
  max-width: 120px;
  .MuiInputBase-root {
    background-color: ${({ theme }) => theme.colors.white};
    padding-left: 8px;
  }

  input,
  textarea {
    font-size: 14px;
    padding: 6px 12px;
    padding-left: ${({ currency }) => (currency ? 0 : 12)}px !important;
    background-color: ${({ theme }) => theme.colors.white};
  }

  input::placeholder,
  textarea::placeholder {
    font-size: 14px;
  }
`;
